// // ==================================
// // AddEditBatchExamMaster.jsx (FULL UI)
// // ✅ pattern_name saves
// // ✅ NEW: Start/End date default = today
// // ✅ NEW: Start/End date min = today (no past date)
// // ✅ NEW: Exam Date default = today (on load rows)
// // ✅ NEW: Exam Date min = today (no past date)
// // ✅ NEW: Exam Date required validation (shows red border + message)
// // ==================================

// import React, { useEffect, useMemo, useState, useCallback } from 'react';
// import {
//   Card,
//   Row,
//   CardTitle,
//   CardBody,
//   Button,
//   FormGroup,
//   Label,
//   Input,
//   Table,
//   FormText,
// } from 'reactstrap';
// import { useNavigate, useLocation } from 'react-router-dom';
// import VendorBranchSelector from '../../components/VendorBranchSelector';
// import { useSelector } from 'react-redux';
// import { apiService } from '../../constants/ApiService';
// import { toast } from 'react-toastify';
// import useVendorBranch from '../../utils/useVendorBranch';
// import conditionalDataLoad from '../../utils/conditionalDataLoad';
// import Select from 'react-select';

// const pick = (...vals) =>
//   vals.find((v) => v !== undefined && v !== null && v !== '');

// const getCaseInsensitive = (obj, key) => {
//   if (!obj || typeof obj !== 'object') return undefined;
//   const foundKey = Object.keys(obj).find(
//     (k) => k.toLowerCase() === String(key).toLowerCase(),
//   );
//   return foundKey ? obj[foundKey] : undefined;
// };

// const normalizeArray = (payload) => {
//   if (!payload) return [];
//   if (Array.isArray(payload)) return payload;

//   const directKeys = [
//     'Data',
//     'data',
//     'ClassSubjectList',
//     'classSubjectList',
//     'List',
//     'list',
//     'Result',
//     'result',
//     'Items',
//     'items',
//     'singleRecord',
//     'SingleRecord',
//   ];

//   for (const k of directKeys) {
//     const v = getCaseInsensitive(payload, k);
//     if (Array.isArray(v)) return v;
//   }

//   const nested1 = getCaseInsensitive(payload, 'data');
//   const nested2 = getCaseInsensitive(payload, 'Data');

//   if (nested1 && typeof nested1 === 'object') {
//     const a = normalizeArray(nested1);
//     if (a.length) return a;
//   }
//   if (nested2 && typeof nested2 === 'object') {
//     const a = normalizeArray(nested2);
//     if (a.length) return a;
//   }

//   return [];
// };

// const flattenIfGrouped = (arr) => {
//   if (!Array.isArray(arr) || arr.length === 0) return [];

//   const hasInnerList = arr.some((x) => {
//     const a1 = getCaseInsensitive(x, 'SubjectList');
//     const a2 = getCaseInsensitive(x, 'subjectList');
//     const a3 = getCaseInsensitive(x, 'Subjects');
//     const a4 = getCaseInsensitive(x, 'subjects');
//     return (
//       Array.isArray(a1) ||
//       Array.isArray(a2) ||
//       Array.isArray(a3) ||
//       Array.isArray(a4)
//     );
//   });

//   if (!hasInnerList) return arr;

//   const flat = [];
//   arr.forEach((x) => {
//     const a1 = getCaseInsensitive(x, 'SubjectList');
//     const a2 = getCaseInsensitive(x, 'subjectList');
//     const a3 = getCaseInsensitive(x, 'Subjects');
//     const a4 = getCaseInsensitive(x, 'subjects');

//     const inner =
//       (Array.isArray(a1) && a1) ||
//       (Array.isArray(a2) && a2) ||
//       (Array.isArray(a3) && a3) ||
//       (Array.isArray(a4) && a4) ||
//       [];

//     inner.forEach((y) => flat.push(y));
//   });

//   return flat;
// };

// // ✅ Today date in YYYY-MM-DD (timezone-safe)
// const getTodayInputDate = () => {
//   const d = new Date();
//   const yyyy = d.getFullYear();
//   const mm = String(d.getMonth() + 1).padStart(2, '0');
//   const dd = String(d.getDate()).padStart(2, '0');
//   return `${yyyy}-${mm}-${dd}`;
// };

// const TODAY = getTodayInputDate();

// // ✅ Date helper (timezone-safe)
// const DateHelper = {
//   toInputDate(d) {
//     if (!d) return '';
//     if (typeof d === 'string') {
//       const s = d.trim();
//       if (/^\d{4}-\d{2}-\d{2}/.test(s)) return s.slice(0, 10);
//     }
//     const dt = new Date(d);
//     if (Number.isNaN(dt.getTime())) return '';
//     const yyyy = dt.getFullYear();
//     const mm = String(dt.getMonth() + 1).padStart(2, '0');
//     const dd = String(dt.getDate()).padStart(2, '0');
//     return `${yyyy}-${mm}-${dd}`;
//   },
// };

// // -----------------------------
// // Course Structure helpers
// // -----------------------------
// const normalizeCourseStructure = (raw) => {
//   const s = String(raw ?? '')
//     .trim()
//     .toLowerCase();
//   if (!s) return 'semester';
//   if (s.includes('year')) return 'year';
//   if (s.includes('month')) return 'month';
//   if (s.includes('sem')) return 'semester';
//   return 'semester';
// };

// const structureWordUpper = (raw) => {
//   const s = normalizeCourseStructure(raw);
//   if (s === 'year') return 'YEAR';
//   if (s === 'month') return 'MONTH';
//   return 'SEMESTER';
// };

// const structureHeader = (raw, index1Based) =>
//   `${structureWordUpper(raw)} - ${index1Based}`;

// // -----------------------------
// // Pattern helpers
// // -----------------------------
// const getPatternId = (p) =>
//   Number(p?.id ?? p?.pattern_id ?? p?.PatternId ?? p?.ID ?? 0) || 0;

// const getPatternTermName = (p) =>
//   String(
//     pick(
//       p?.term_name,
//       p?.Term_Name,
//       p?.termName,
//       p?.TermName,
//       p?.pattern_name,
//       p?.PatternName,
//       p?.name,
//       p?.Name,
//       '',
//     ),
//   );

// // -----------------------------
// // Subject pickers
// // -----------------------------
// const pickSubjectId = (s) => {
//   const direct =
//     s?.subject_id ??
//     s?.SubjectId ??
//     s?.Subject_ID ??
//     s?.subjectId ??
//     s?.SubjectID ??
//     s?.id ??
//     s?.ID ??
//     s?.subject_master_id ??
//     s?.subjectMasterId ??
//     s?.SubjectMasterId;

//   const nested =
//     s?.subject?.id ??
//     s?.subject?.subject_id ??
//     s?.Subject?.id ??
//     s?.Subject?.subject_id;

//   return Number(direct ?? nested ?? 0);
// };

// const pickSubjectName = (s) => {
//   const direct =
//     s?.subject_name ?? s?.Subject_Name ?? s?.name ?? s?.Name ?? s?.subjectName;

//   const nested =
//     s?.subject?.subject_name ??
//     s?.subject?.name ??
//     s?.Subject?.subject_name ??
//     s?.Subject?.name;

//   return String(direct ?? nested ?? '');
// };

// const pickSubjectCode = (s) => {
//   const direct =
//     s?.subject_code ?? s?.Subject_Code ?? s?.code ?? s?.subjectCode;

//   const nested =
//     s?.subject?.subject_code ??
//     s?.subject?.code ??
//     s?.Subject?.subject_code ??
//     s?.Subject?.code;

//   return String(direct ?? nested ?? '');
// };

// const pickSubjectSemesterNo = (s) => {
//   const v =
//     s?.semester ??
//     s?.Semester ??
//     s?.semester_no ??
//     s?.Semester_No ??
//     s?.semesterNo ??
//     getCaseInsensitive(s, 'semester') ??
//     getCaseInsensitive(s, 'semester_no') ??
//     getCaseInsensitive(s, 'semesterNo') ??
//     1;

//   return Number(v || 1);
// };

// // -----------------------------
// // Batch helpers
// // -----------------------------
// const getBatchId = (b) =>
//   Number(b?.id ?? b?.batch_id ?? b?.ID ?? b?.BatchId ?? 0) || 0;
// const getBatchName = (b) =>
//   String(pick(b?.batch_name, b?.BatchName, b?.name, b?.Name, ''));
// const getBatchCode = (b) =>
//   String(pick(b?.batch_code, b?.BatchCode, b?.code, b?.Code, ''));

// // ✅ react-select style
// const selectStyles = {
//   control: (base) => ({ ...base, minHeight: 36, height: 36, fontSize: 14 }),
//   valueContainer: (base) => ({ ...base, height: 36, padding: '0 8px' }),
//   input: (base) => ({ ...base, margin: 0, padding: 0 }),
//   indicatorsContainer: (base) => ({ ...base, height: 36 }),
// };

// const AddEditBatchExamMaster = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const { user } = useSelector((state) => state.authState);
//   const { isSuperAdmin, isAdmin, hasMultiBranch, hasSingleBranch } =
//     useVendorBranch(user);

//   const [batchErrors, setBatchErrors] = useState({});

//   const [courseOptions, setCourseOptions] = useState([]);
//   const [courseLoading, setCourseLoading] = useState(false);

//   const [batchOptions, setBatchOptions] = useState([]);
//   const [batchLoading, setBatchLoading] = useState(false);

//   const [patternOptions, setPatternOptions] = useState([]);
//   const [patternLoading, setPatternLoading] = useState(false);

//   const [selectedSemester, setSelectedSemester] = useState('');
//   const [isLoaded, setIsLoaded] = useState(false);

//   const [subjectsLoading, setSubjectsLoading] = useState(false);
//   const [allSubjects, setAllSubjects] = useState([]);
//   const [existingSchedule, setExistingSchedule] = useState([]);
//   const [scheduleRows, setScheduleRows] = useState([]);

//   // ✅ NEW: examDate errors map { subject_id: "Required" }
//   const [examDateErrors, setExamDateErrors] = useState({});

//   const [batchExamData, setBatchExamData] = useState({
//     id: 0,
//     vendor_id: '',
//     branch_id: '',

//     class_id: '',
//     class_name: '',
//     total_semester: 0,
//     course_structure: 'semester',

//     batch_id: '',
//     batch_name: '',
//     batch_code: '',

//     pattern_id: '',
//     pattern_name: '',

//     // ✅ NEW: default today
//     start_date: TODAY,
//     end_date: TODAY,

//     is_published: false,
//     exam_conduct_status: 'Planned',

//     sem_no: null,
//   });

//   const isEditMode = useMemo(
//     () => Number(batchExamData.id || 0) > 0,
//     [batchExamData.id],
//   );

//   const asList = (data) => {
//     if (Array.isArray(data)) return data;
//     const arr = normalizeArray(data);
//     return Array.isArray(arr) ? arr : [];
//   };

//   const extractList = (response) => {
//     if (!response) return [];
//     let list = asList(response.data);
//     if (!list.length) list = asList(response);
//     return Array.isArray(list) ? list : [];
//   };

//   // -----------------------------------------
//   // ✅ Prefill from navigation state (EDIT)
//   // -----------------------------------------
//   useEffect(() => {
//     const st = location.state;
//     if (!st) return;

//     const semFromState =
//       Number(st?.sem_no ?? st?.semNo ?? st?.semester_no ?? 0) || null;

//     setBatchExamData((prev) => ({
//       ...prev,
//       ...st,
//       vendor_id: st.vendor_id ?? prev.vendor_id,
//       branch_id: st.branch_id ?? prev.branch_id,

//       class_id: st.class_id ?? st.classId ?? prev.class_id,
//       class_name: st.class_name ?? st.className ?? prev.class_name,

//       batch_id: st.batch_id ?? st.batchId ?? prev.batch_id,
//       batch_name: st.batch_name ?? st.batchName ?? prev.batch_name,
//       batch_code: st.batch_code ?? st.batchCode ?? prev.batch_code,

//       pattern_id: st.pattern_id ?? st.patternId ?? prev.pattern_id,
//       pattern_name: st.pattern_name ?? prev.pattern_name ?? '',

//       total_semester: Number(
//         st.total_semester ?? st.totalSemester ?? prev.total_semester ?? 0,
//       ),
//       course_structure: normalizeCourseStructure(
//         st.course_structure || st.courseStructure || prev.course_structure,
//       ),

//       // ✅ if API gives past date, still show it; but user cannot pick past now
//       start_date: st.start_date
//         ? DateHelper.toInputDate(st.start_date)
//         : prev.start_date || TODAY,
//       end_date: st.end_date
//         ? DateHelper.toInputDate(st.end_date)
//         : prev.end_date || TODAY,

//       exam_conduct_status:
//         st.exam_conduct_status ?? prev.exam_conduct_status ?? 'Planned',
//       sem_no: semFromState ?? prev.sem_no ?? null,
//     }));

//     if (Number(st?.id || 0) > 0 && semFromState) {
//       setSelectedSemester(String(semFromState));
//       setIsLoaded(true);
//     } else {
//       setSelectedSemester('');
//       setIsLoaded(false);
//       setScheduleRows([]);
//     }
//   }, [location.state]);

//   // -----------------------------------------
//   // ✅ Courses
//   // -----------------------------------------
//   const fetchCourses = async (searchText = '') => {
//     try {
//       const vendorId = batchExamData.vendor_id || '';
//       const branchId = batchExamData.branch_id || '';

//       // if (!vendorId || !branchId) {
//       //   setCourseOptions([]);
//       //   return;
//       // }

//       setCourseLoading(true);

//       const res = await apiService.get(
//         `api/ClassMaster/GetClassMaster?vendorId=${vendorId}&branchId=${branchId}&searchItem=${encodeURIComponent(
//           searchText || '',
//         )}`,
//       );

//       if (res?.status === true) {
//         const list = extractList(res) || [];

//         const opts = (list || []).map((x) => ({
//           value: Number(x?.id ?? x?.class_id ?? x?.ClassId ?? 0),
//           label: pick(
//             x?.class_Name,
//             x?.class_name,
//             x?.class_display_name,
//             x?.className,
//             x?.course_name,
//             'No Name',
//           ),
//           meta: {
//             total_semester:
//               Number(
//                 pick(x?.total_semester, x?.Total_Semester, x?.totalSemester, 0),
//               ) || 0,
//             course_structure: normalizeCourseStructure(
//               pick(
//                 x?.course_structure,
//                 x?.Course_Structure,
//                 x?.courseStructure,
//                 'semester',
//               ),
//             ),
//           },
//         }));

//         setCourseOptions(opts.filter((o) => o.value > 0));
//       } else {
//         setCourseOptions([]);
//       }
//     } catch (err) {
//       console.log(err);
//       setCourseOptions([]);
//     } finally {
//       setCourseLoading(false);
//     }
//   };

//   useEffect(() => {
//     const canLoad = conditionalDataLoad({
//       hasMultiBranch,
//       hasSingleBranch,
//       isSuperAdmin,
//       isAdmin,
//       vendorId: batchExamData.vendor_id,
//       branchId: batchExamData.branch_id,
//     });

//     if (!canLoad) return;
//     fetchCourses('');
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [batchExamData.vendor_id, batchExamData.branch_id]);

//   // -----------------------------------------
//   // ✅ Batches
//   // -----------------------------------------
//   const fetchBatches = async (classId, searchText = '') => {
//     try {
//       const vendorId = batchExamData.vendor_id || '';
//       const branchId = batchExamData.branch_id || '';
//       // if (!vendorId || !branchId || !classId) {
//       //   setBatchOptions([]);
//       //   return;
//       // }

//       setBatchLoading(true);

//       const res = await apiService.get(
//         `api/BatchMaster/GetAllBatch?vendorId=${vendorId}&branchId=${branchId}&classId=${classId}&search=${encodeURIComponent(
//           searchText || '',
//         )}`,
//       );

//       if (res?.status === true) {
//         const list = extractList(res) || [];

//         const opts = (list || []).map((b) => {
//           const id = getBatchId(b);
//           const name = getBatchName(b);
//           const code = getBatchCode(b);
//           return {
//             value: id,
//             label: code ? `${code} - ${name}` : name || `Batch-${id}`,
//             meta: { name, code },
//           };
//         });

//         setBatchOptions(opts.filter((o) => o.value > 0));
//       } else {
//         setBatchOptions([]);
//       }
//     } catch (e) {
//       console.log(e);
//       setBatchOptions([]);
//     } finally {
//       setBatchLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (!batchExamData.class_id) {
//       setBatchOptions([]);
//       return;
//     }
//     fetchBatches(batchExamData.class_id, '');
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [
//     batchExamData.class_id,
//     batchExamData.vendor_id,
//     batchExamData.branch_id,
//   ]);

//   // -----------------------------------------
//   // ✅ Patterns
//   // -----------------------------------------
//   const fetchPatterns = async (searchText = '') => {
//     try {
//       const vendorId = batchExamData.vendor_id || '';
//       const branchId = batchExamData.branch_id || '';
//       const courseId = batchExamData.class_id || '';

//       // if (!vendorId || !branchId || !courseId) {
//       //   setPatternOptions([]);
//       //   return;
//       // }

//       setPatternLoading(true);

//       const res = await apiService.get(
//         `api/ExamMaster/GetAllCourseExamPattern?courseId=${courseId}&vendorId=${vendorId}&branchId=${branchId}&search=${encodeURIComponent(
//           searchText || '',
//         )}`,
//       );

//       if (res?.status === true) {
//         const list = extractList(res) || [];

//         const opts = (list || []).map((p) => {
//           const id = getPatternId(p);
//           const term = getPatternTermName(p);
//           return { value: id, label: term || `Pattern-${id}` };
//         });

//         setPatternOptions(opts.filter((o) => o.value > 0));
//       } else {
//         setPatternOptions([]);
//       }
//     } catch (e) {
//       console.log(e);
//       setPatternOptions([]);
//     } finally {
//       setPatternLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (!batchExamData.class_id) {
//       setPatternOptions([]);
//       return;
//     }
//     fetchPatterns('');
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [
//     batchExamData.class_id,
//     batchExamData.vendor_id,
//     batchExamData.branch_id,
//   ]);

//   const selectedPatternTerm = useMemo(() => {
//     const pid = Number(batchExamData.pattern_id || 0);
//     if (!pid) return '';
//     const found = patternOptions.find((p) => Number(p.value) === pid);
//     return found?.label || batchExamData.pattern_name || '';
//   }, [batchExamData.pattern_id, batchExamData.pattern_name, patternOptions]);

//   // -----------------------------------------
//   // ✅ Subjects / Schedule APIs
//   // -----------------------------------------
//   const GetClassSubjects = async () => {
//     try {
//       const vendorId = batchExamData.vendor_id || '';
//       const branchId = batchExamData.branch_id || '';
//       const classId = batchExamData.class_id || '';
//       // if (!vendorId || !branchId || !classId) return [];

//       const response = await apiService.get(
//         `api/ClassMaster/GetClassSubjects?classId=${classId}&vendorId=${vendorId}&branchId=${branchId}`,
//       );

//       if (response?.status === true) {
//         let list = extractList(response);
//         list = flattenIfGrouped(list);

//         const cleaned = (Array.isArray(list) ? list : [])
//           .map((s) => ({
//             subject_id: pickSubjectId(s),
//             subject_name: pickSubjectName(s),
//             subject_code: pickSubjectCode(s),
//             semester_no: pickSubjectSemesterNo(s) || 1,
//           }))
//           .filter((x) => Number(x.subject_id) > 0);

//         return cleaned;
//       }

//       toast.error(response?.message || 'Failed to load subjects');
//       return [];
//     } catch (error) {
//       console.log(error);
//       toast.error('Something went wrong!!');
//       return [];
//     }
//   };

//   const GetAllBatchExamSubSchedule = async (
//     search = '',
//     forceMasterId = null,
//   ) => {
//     try {
//       const vendorId = batchExamData.vendor_id || '';
//       const branchId = batchExamData.branch_id || '';
//       const masterId = Number(forceMasterId ?? batchExamData.id ?? 0);

//       // if (!vendorId || !branchId || !masterId) return [];

//       const response = await apiService.get(
//         `api/BatchExamMaster/GetAllBatchExamSubSchedule?vendorId=${vendorId}&branchId=${branchId}&batchExamId=${masterId}&search=${search}`,
//       );

//       if (response?.status === true) {
//         const list = extractList(response);

//         return (Array.isArray(list) ? list : []).map((x) => ({
//           id: x?.id ?? null,
//           subject_id: Number(x?.subject_id ?? 0) || 0,
//           exam_date: DateHelper.toInputDate(x?.exam_date),
//           subject_code: x?.subject_code ?? '',
//           subject_name: x?.subject_name ?? '',
//         }));
//       }
//       return [];
//     } catch (error) {
//       console.log(error);
//       return [];
//     }
//   };

//   // ✅ NEW: default exam_date = TODAY for new rows
//   const buildRowsForSemester = (semNo, subjectsArr, scheduleArr) => {
//     const subjectsOfSem = (subjectsArr || []).filter(
//       (s) => Number(s.semester_no || 1) === Number(semNo),
//     );

//     const exMap = {};
//     (scheduleArr || []).forEach((x) => {
//       const sid = Number(x.subject_id || 0);
//       if (!sid) return;
//       exMap[sid] = {
//         id: x.id ?? null,
//         exam_date: x.exam_date || '',
//         subject_code: x.subject_code || '',
//         subject_name: x.subject_name || '',
//       };
//     });

//     return subjectsOfSem.map((s) => ({
//       id: exMap[s.subject_id]?.id ?? null,
//       subject_id: s.subject_id,
//       subject_name: s.subject_name || exMap[s.subject_id]?.subject_name || '',
//       subject_code: s.subject_code || exMap[s.subject_id]?.subject_code || '',
//       semester_no: s.semester_no || semNo,

//       // ✅ default today if empty
//       exam_date: exMap[s.subject_id]?.exam_date ?? TODAY,
//     }));
//   };

//   const preloadSubjectsAndExisting = useCallback(async () => {
//     const vendorId = batchExamData.vendor_id;
//     const branchId = batchExamData.branch_id;
//     const classId = batchExamData.class_id;
//     const masterId = Number(batchExamData.id || 0);

//     // if (!vendorId || !branchId || !classId) {
//     //   setAllSubjects([]);
//     //   setExistingSchedule([]);
//     //   setIsLoaded(false);
//     //   setScheduleRows([]);
//     //   return;
//     // }

//     try {
//       setSubjectsLoading(true);

//       const subjects = await GetClassSubjects();

//       let existing = [];
//       if (masterId > 0)
//         existing = await GetAllBatchExamSubSchedule('', masterId);

//       setAllSubjects(subjects || []);
//       setExistingSchedule(existing || []);

//       if (masterId > 0) {
//         let sem = Number(batchExamData.sem_no || 0);
//         if (!sem && selectedSemester) sem = Number(selectedSemester || 0);
//         const finalSem = sem || 1;

//         setSelectedSemester(String(finalSem));

//         const rows = buildRowsForSemester(
//           finalSem,
//           subjects || [],
//           existing || [],
//         );
//         setScheduleRows(rows);
//         setIsLoaded(true);
//       } else {
//         setIsLoaded(false);
//         setScheduleRows([]);
//       }
//     } finally {
//       setSubjectsLoading(false);
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [
//     batchExamData.vendor_id,
//     batchExamData.branch_id,
//     batchExamData.class_id,
//     batchExamData.id,
//     batchExamData.sem_no,
//     selectedSemester,
//   ]);

//   useEffect(() => {
//     preloadSubjectsAndExisting();
//   }, [preloadSubjectsAndExisting]);

//   // -----------------------------------------
//   // ✅ react-select handlers
//   // -----------------------------------------
//   const onCourseSelect = (opt) => {
//     const classId = opt?.value || '';

//     setSelectedSemester('');
//     setIsLoaded(false);
//     setScheduleRows([]);
//     setExistingSchedule([]);
//     setExamDateErrors({});

//     setBatchExamData((prev) => ({
//       ...prev,
//       class_id: classId ? String(classId) : '',
//       class_name: opt?.label || '',
//       total_semester: opt?.meta?.total_semester || 0,
//       course_structure: opt?.meta?.course_structure || 'semester',

//       batch_id: '',
//       batch_name: '',
//       batch_code: '',
//       pattern_id: '',
//       pattern_name: '',

//       sem_no: null,

//       // ✅ keep today default
//       start_date: prev.start_date || TODAY,
//       end_date: prev.end_date || TODAY,
//     }));

//     if (classId) {
//       fetchBatches(classId, '');
//       fetchPatterns('');
//     } else {
//       setBatchOptions([]);
//       setPatternOptions([]);
//     }
//   };

//   const onBatchSelect = (opt) => {
//     setBatchExamData((prev) => ({
//       ...prev,
//       batch_id: opt?.value ? String(opt.value) : '',
//       batch_name: opt?.meta?.name || '',
//       batch_code: opt?.meta?.code || '',
//     }));
//   };

//   const onPatternSelect = (opt) => {
//     const pid = opt?.value ? String(opt.value) : '';
//     const pname = opt?.label || '';

//     setBatchExamData((prev) => ({
//       ...prev,
//       pattern_id: pid,
//       pattern_name: pname,
//     }));

//     if (!isEditMode) {
//       setIsLoaded(false);
//       setScheduleRows([]);
//       setExamDateErrors({});
//     }
//   };

//   // -----------------------------------------
//   // ✅ Semester change
//   // -----------------------------------------
//   const onSemesterChange = (val) => {
//     setSelectedSemester(val);

//     const semNo = Number(val || 0) || null;
//     setBatchExamData((prev) => ({
//       ...prev,
//       sem_no: semNo,
//     }));

//     setExamDateErrors({});

//     if (!semNo) {
//       setIsLoaded(false);
//       setScheduleRows([]);
//       return;
//     }

//     if (isEditMode) {
//       const rows = buildRowsForSemester(
//         semNo,
//         allSubjects || [],
//         existingSchedule || [],
//       );
//       setScheduleRows(rows);
//       setIsLoaded(true);
//     } else {
//       setIsLoaded(false);
//       setScheduleRows([]);
//     }
//   };

//   // -----------------------------------------
//   // ✅ Load button (ADD only)
//   // -----------------------------------------
//   const onLoadClick = () => {
//     const vendorId = batchExamData.vendor_id;
//     const branchId = batchExamData.branch_id;
//     const classId = batchExamData.class_id;

//     const patternId = Number(batchExamData.pattern_id || 0);
//     const semNo = Number(selectedSemester || 0);

//     // if (!vendorId || !branchId || !classId) {
//     //   toast.error('Please select Vendor/Branch/Course');
//     //   return;
//     // }
//     if (!batchExamData.batch_id || Number(batchExamData.batch_id) <= 0) {
//       toast.error('Please select Batch Name');
//       return;
//     }
//     if (!patternId) {
//       toast.error('Please select Pattern');
//       return;
//     }
//     if (!semNo) {
//       toast.error(
//         `Please select ${structureWordUpper(batchExamData.course_structure)}`,
//       );
//       return;
//     }

//     const rows = buildRowsForSemester(
//       semNo,
//       allSubjects || [],
//       existingSchedule || [],
//     );

//     if (!rows.length) {
//       toast.error(
//         `No subjects found for ${structureHeader(batchExamData.course_structure, semNo)}`,
//       );
//       setScheduleRows([]);
//       setIsLoaded(false);
//       return;
//     }

//     setScheduleRows(rows);
//     setIsLoaded(true);
//     setExamDateErrors({});
//   };

//   // ✅ NEW: exam date change + clear error
//   const updateExamDate = (subjectId, value) => {
//     setScheduleRows((prev) =>
//       prev.map((r) =>
//         Number(r.subject_id) === Number(subjectId)
//           ? { ...r, exam_date: value }
//           : r,
//       ),
//     );

//     setExamDateErrors((prev) => {
//       if (!prev || !prev[subjectId]) return prev;
//       const clone = { ...prev };
//       delete clone[subjectId];
//       return clone;
//     });
//   };

//   // -----------------------------------------
//   // ✅ Validation
//   // -----------------------------------------
//   const validateBeforeSave = () => {
//     setExamDateErrors({});

//     if (
//       isSuperAdmin &&
//       (!batchExamData.vendor_id || Number(batchExamData.vendor_id) <= 0)
//     ) {
//       toast.error('Please select Vendor');
//       return false;
//     }

//     if (
//       (isSuperAdmin || isAdmin || hasMultiBranch) &&
//       (!batchExamData.branch_id || Number(batchExamData.branch_id) <= 0)
//     ) {
//       toast.error('Please select Branch');
//       return false;
//     }

//     if (!batchExamData.class_id || Number(batchExamData.class_id) <= 0) {
//       toast.error('Please select Course/Class');
//       return false;
//     }

//     if (!batchExamData.batch_id || Number(batchExamData.batch_id) <= 0) {
//       toast.error('Please select Batch Name');
//       return false;
//     }

//     if (!batchExamData.pattern_id || Number(batchExamData.pattern_id) <= 0) {
//       toast.error('Please select Pattern');
//       return false;
//     }

//     if (!selectedSemester || Number(selectedSemester) <= 0) {
//       toast.error(
//         `Please select ${structureWordUpper(batchExamData.course_structure)}`,
//       );
//       return false;
//     }

//     if (!isLoaded) {
//       toast.error(isEditMode ? 'Schedule not loaded' : 'Please click Load');
//       return false;
//     }

//     if (!batchExamData.exam_conduct_status) {
//       toast.error('Please select Exam Conduct Status');
//       return false;
//     }

//     if (!batchExamData.start_date) {
//       toast.error('Please select Start Date');
//       return false;
//     }

//     if (!batchExamData.end_date) {
//       toast.error('Please select End Date');
//       return false;
//     }

//     // ✅ past not allowed (extra safety)
//     if (batchExamData.start_date < TODAY) {
//       toast.error('Start Date past में नहीं हो सकती।');
//       return false;
//     }
//     if (batchExamData.end_date < TODAY) {
//       toast.error('End Date past में नहीं हो सकती।');
//       return false;
//     }

//     if (batchExamData.end_date < batchExamData.start_date) {
//       toast.error('End Date, Start Date से छोटी नहीं हो सकती।');
//       return false;
//     }

//     // ✅ Exam Date required validation (हर subject के लिए)
//     const errs = {};
//     (scheduleRows || []).forEach((r) => {
//       const v = String(r.exam_date || '').trim();
//       if (!v) errs[r.subject_id] = 'Exam Date required है';
//       else if (v < TODAY) errs[r.subject_id] = 'Past date allowed नहीं है';
//     });

//     if (Object.keys(errs).length > 0) {
//       setExamDateErrors(errs);
//       toast.error('कृपया Exam Date भरें (required).');
//       return false;
//     }

//     return true;
//   };

//   // -----------------------------------------
//   // ✅ Save
//   // -----------------------------------------
//   const SaveBatchExamMaster = async () => {
//     if (!validateBeforeSave()) return;

//     try {
//       const payload = {
//         id: batchExamData.id ? Number(batchExamData.id) : null,
//         vendor_id: batchExamData.vendor_id
//           ? Number(batchExamData.vendor_id)
//           : null,
//         branch_id: batchExamData.branch_id
//           ? Number(batchExamData.branch_id)
//           : null,

//         class_id: batchExamData.class_id
//           ? Number(batchExamData.class_id)
//           : null,
//         class_name: batchExamData.class_name || null,

//         batch_id: batchExamData.batch_id
//           ? Number(batchExamData.batch_id)
//           : null,
//         batch_name: batchExamData.batch_name || null,
//         batch_code: batchExamData.batch_code || null,

//         pattern_id: batchExamData.pattern_id
//           ? Number(batchExamData.pattern_id)
//           : null,
//         pattern_name: batchExamData.pattern_name || selectedPatternTerm || null,

//         start_date: batchExamData.start_date || null,
//         end_date: batchExamData.end_date || null,

//         is_published: !!batchExamData.is_published,
//         exam_conduct_status: batchExamData.exam_conduct_status,

//         sem_no: Number(selectedSemester || 0) || null,

//         sub_schedule_list: (scheduleRows || [])
//           .filter((r) => Number(r.subject_id) > 0)
//           .map((r) => ({
//             id: r?.id ? Number(r.id) : null,
//             subject_id: Number(r.subject_id),
//             exam_date: r.exam_date || null,

//             subject_code: r.subject_code || null,
//             subject_name: r.subject_name || null,

//             vendor_id: batchExamData.vendor_id
//               ? Number(batchExamData.vendor_id)
//               : null,
//             branch_id: batchExamData.branch_id
//               ? Number(batchExamData.branch_id)
//               : null,

//             exam_conduct_status: batchExamData.exam_conduct_status,
//             class_id: batchExamData.class_id
//               ? Number(batchExamData.class_id)
//               : null,
//             class_name: batchExamData.class_name || null,
//             batch_name: batchExamData.batch_name || null,
//             batch_code: batchExamData.batch_code || null,
//           })),
//       };

//       let res;
//       if (batchExamData.id && Number(batchExamData.id) > 0) {
//         res = await apiService.put(
//           `api/BatchExamMaster/UpdateBatchExamMaster?id=${batchExamData.id}`,
//           payload,
//         );
//       } else {
//         res = await apiService.post(
//           'api/BatchExamMaster/AddBatchExamMaster',
//           payload,
//         );
//       }

//       if (res?.status === true) {
//         toast.success(res.message || 'Saved');
//         navigate('/list-batch-exam');
//       } else {
//         toast.error(res?.message || 'Failed');
//       }
//     } catch (err) {
//       console.error(err);
//       toast.error('Something went wrong');
//     }
//   };

//   // -----------------------------------------
//   // UI
//   // -----------------------------------------
//   const courseStructure = batchExamData.course_structure || 'semester';
//   const totalSemesters = Number(batchExamData.total_semester || 0);

//   const canLoad =
//     !!batchExamData.class_id &&
//     Number(batchExamData.class_id) > 0 &&
//     !!batchExamData.batch_id &&
//     Number(batchExamData.batch_id) > 0 &&
//     !!batchExamData.pattern_id &&
//     Number(batchExamData.pattern_id) > 0 &&
//     !!selectedSemester &&
//     Number(selectedSemester) > 0;

//   const selectedCourseOpt = useMemo(
//     () =>
//       courseOptions.find(
//         (o) => Number(o.value) === Number(batchExamData.class_id),
//       ) || null,
//     [courseOptions, batchExamData.class_id],
//   );

//   const selectedBatchOpt = useMemo(
//     () =>
//       batchOptions.find(
//         (o) => Number(o.value) === Number(batchExamData.batch_id),
//       ) || null,
//     [batchOptions, batchExamData.batch_id],
//   );

//   const selectedPatternOpt = useMemo(
//     () =>
//       patternOptions.find(
//         (o) => Number(o.value) === Number(batchExamData.pattern_id),
//       ) || null,
//     [patternOptions, batchExamData.pattern_id],
//   );

//   return (
//     <>
//       <VendorBranchSelector
//         user={user}
//         selectionData={batchExamData}
//         setSelectionData={setBatchExamData}
//         errorMessage={batchErrors}
//         accessButton={true}
//       />

//       <Card className='card-box pd-20 mb-20'>
//         <CardTitle className='border-bottom p-3 d-flex justify-content-between align-items-center'>
//           <span>Batch Exam Master Form</span>

//           <div className='d-flex gap-2'>
//             <Button color='primary' onClick={SaveBatchExamMaster}>
//               Save
//             </Button>
//             <Button color='warning' onClick={() => navigate(-1)}>
//               <i className='bi bi-arrow-left' />
//             </Button>
//           </div>
//         </CardTitle>

//         <CardBody>
//           <Row>
//             <FormGroup className='col-sm-6'>
//               <Label>Course / Class</Label>
//               <Select
//                 styles={selectStyles}
//                 options={courseOptions}
//                 value={selectedCourseOpt}
//                 isLoading={courseLoading}
//                 isSearchable
//                 isClearable
//                 placeholder='Search courses ...'
//                 onChange={onCourseSelect}
//                 onInputChange={(inputValue, actionMeta) => {
//                   if (actionMeta.action === 'input-change')
//                     fetchCourses(inputValue);
//                 }}
//               />
//             </FormGroup>

//             <FormGroup className='col-sm-6'>
//               <Label>Batch Name</Label>
//               <Select
//                 styles={selectStyles}
//                 options={batchOptions}
//                 value={selectedBatchOpt}
//                 isLoading={batchLoading}
//                 isSearchable
//                 isClearable
//                 placeholder='Search batches ...'
//                 onChange={onBatchSelect}
//                 onInputChange={(inputValue, actionMeta) => {
//                   if (actionMeta.action === 'input-change')
//                     fetchBatches(batchExamData.class_id, inputValue);
//                 }}
//                 isDisabled={!batchExamData.class_id}
//               />
//             </FormGroup>

//             <FormGroup className='col-sm-6'>
//               <Label>Pattern (Term Name)</Label>
//               <Select
//                 styles={selectStyles}
//                 options={patternOptions}
//                 value={selectedPatternOpt}
//                 isLoading={patternLoading}
//                 isSearchable
//                 isClearable
//                 placeholder='Search patterns ...'
//                 onChange={onPatternSelect}
//                 onInputChange={(inputValue, actionMeta) => {
//                   if (actionMeta.action === 'input-change')
//                     fetchPatterns(inputValue);
//                 }}
//                 isDisabled={!batchExamData.class_id}
//               />
//               {batchExamData.pattern_id ? (
//                 <small className='text-muted'>
//                   Selected:{' '}
//                   {selectedPatternTerm ||
//                     `Pattern ID: ${batchExamData.pattern_id}`}
//                 </small>
//               ) : null}
//             </FormGroup>

//             <FormGroup className='col-sm-6'>
//               <Label>Select {structureWordUpper(courseStructure)}</Label>
//               <select
//                 className='form-control'
//                 value={selectedSemester}
//                 onChange={(e) => onSemesterChange(e.target.value)}
//                 disabled={!totalSemesters}
//               >
//                 <option value=''>
//                   {totalSemesters ? 'Select' : 'Select Course first'}
//                 </option>
//                 {[...Array(totalSemesters || 0)].map((_, index) => (
//                   <option key={index + 1} value={index + 1}>
//                     {structureWordUpper(courseStructure)} {index + 1}
//                   </option>
//                 ))}
//               </select>
//             </FormGroup>

//             <FormGroup className='col-sm-3'>
//               <Label>Exam Conduct Status</Label>
//               <Input
//                 type='select'
//                 className='custom-select'
//                 name='exam_conduct_status'
//                 value={batchExamData.exam_conduct_status || ''}
//                 onChange={(e) =>
//                   setBatchExamData((p) => ({
//                     ...p,
//                     exam_conduct_status: e.target.value,
//                   }))
//                 }
//               >
//                 <option value='Planned'>Planned</option>
//                 <option value='Scheduled'>Scheduled</option>
//                 <option value='Conducted'>Conducted</option>
//               </Input>
//             </FormGroup>

//             <FormGroup className='col-sm-3'>
//               <Label>Start Date</Label>
//               <Input
//                 type='date'
//                 value={batchExamData.start_date || TODAY}
//                 min={TODAY} // ✅ no past date
//                 onChange={(e) =>
//                   setBatchExamData((p) => ({
//                     ...p,
//                     start_date: e.target.value,
//                   }))
//                 }
//               />
//             </FormGroup>

//             <FormGroup className='col-sm-3'>
//               <Label>End Date</Label>
//               <Input
//                 type='date'
//                 value={batchExamData.end_date || TODAY}
//                 min={TODAY} // ✅ no past date
//                 onChange={(e) =>
//                   setBatchExamData((p) => ({ ...p, end_date: e.target.value }))
//                 }
//               />
//             </FormGroup>

//             <FormGroup className='col-sm-3 d-flex align-items-center'>
//               <Label check className='mt-4'>
//                 <Input
//                   type='checkbox'
//                   checked={!!batchExamData.is_published}
//                   onChange={(e) =>
//                     setBatchExamData((p) => ({
//                       ...p,
//                       is_published: e.target.checked,
//                     }))
//                   }
//                 />{' '}
//                 Published
//               </Label>
//             </FormGroup>

//             {!isEditMode ? (
//               <FormGroup className='col-sm-2 d-flex align-items-end'>
//                 <Button
//                   color='info'
//                   size='sm'
//                   style={{ width: '100%' }}
//                   onClick={onLoadClick}
//                   disabled={!canLoad || subjectsLoading}
//                 >
//                   {subjectsLoading ? '...' : 'Load'}
//                 </Button>
//               </FormGroup>
//             ) : null}
//           </Row>

//           <hr className='my-4' />

//           {subjectsLoading ? (
//             <div className='text-muted'>Loading subjects...</div>
//           ) : !batchExamData.class_id ? (
//             <div className='text-muted'>Please select Course/Class.</div>
//           ) : !batchExamData.batch_id ? (
//             <div className='text-muted'>Please select Batch Name.</div>
//           ) : !batchExamData.pattern_id ? (
//             <div className='text-muted'>Please select Pattern.</div>
//           ) : !selectedSemester ? (
//             <div className='text-muted'>
//               Please select {structureWordUpper(courseStructure)}.
//             </div>
//           ) : !isLoaded ? (
//             <div className='text-muted'>
//               {isEditMode ? (
//                 <>Loading schedule...</>
//               ) : (
//                 <>
//                   Click <b>Load</b> to show subjects.
//                 </>
//               )}
//             </div>
//           ) : (
//             <Table bordered responsive size='sm'>
//               <thead>
//                 <tr>
//                   <th style={{ width: 60 }}>#</th>
//                   <th style={{ width: 200 }}>Subject Code</th>
//                   <th>Subject Name</th>
//                   <th style={{ width: 240 }}>Exam Date</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {scheduleRows.length === 0 ? (
//                   <tr>
//                     <td colSpan={4} className='text-center text-muted'>
//                       No subjects found for selected{' '}
//                       {structureWordUpper(courseStructure)}
//                     </td>
//                   </tr>
//                 ) : (
//                   scheduleRows.map((r, idx) => {
//                     const errMsg = examDateErrors?.[r.subject_id];
//                     return (
//                       <tr key={`${selectedSemester}_${r.subject_id}`}>
//                         <td>{idx + 1}</td>
//                         <td>
//                           <Input
//                             type='text'
//                             value={r.subject_code || ''}
//                             readOnly
//                           />
//                         </td>
//                         <td>
//                           <Input
//                             type='text'
//                             value={r.subject_name || ''}
//                             readOnly
//                           />
//                         </td>
//                         <td>
//                           <Input
//                             type='date'
//                             value={r.exam_date || TODAY}
//                             min={TODAY} // ✅ no past date
//                             className={errMsg ? 'is-invalid' : ''}
//                             onChange={(e) =>
//                               updateExamDate(r.subject_id, e.target.value)
//                             }
//                           />
//                           {errMsg ? (
//                             <FormText color='danger'>{errMsg}</FormText>
//                           ) : null}
//                         </td>
//                       </tr>
//                     );
//                   })
//                 )}
//               </tbody>
//             </Table>
//           )}
//         </CardBody>
//       </Card>
//     </>
//   );
// };

// export default AddEditBatchExamMaster;
//19march
// ==================================
// AddEditBatchExamMaster.jsx (FULL UI)
// ✅ FIXED:
// 1) Add page open par GetClassSubjects call nahi hogi jab tak class_id valid na ho
// 2) class_id / course_id / classId / courseId sab navigation state se safely resolve honge
// 3) BatchList -> Add Batch Exam navigation safe
// 4) fetchPatterns stale state bug fixed
// 5) fetchBatches / fetchPatterns / preload all guarded
// 6) Dev mode me extra re-render ho sakta hai, but invalid API call nahi jayegi
// ==================================

import React, { useEffect, useMemo, useState, useCallback } from 'react';
import {
  Card,
  Row,
  CardTitle,
  CardBody,
  Button,
  FormGroup,
  Label,
  Input,
  Table,
  FormText,
} from 'reactstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import VendorBranchSelector from '../../components/VendorBranchSelector';
import { useSelector } from 'react-redux';
import { apiService } from '../../constants/ApiService';
import { toast } from 'react-toastify';
import useVendorBranch from '../../utils/useVendorBranch';
import conditionalDataLoad from '../../utils/conditionalDataLoad';
import Select from 'react-select';

const pick = (...vals) =>
  vals.find((v) => v !== undefined && v !== null && v !== '');

const toPositiveIntOrNull = (v) => {
  if (v === '' || v === null || v === undefined) return null;
  const n = Number(v);
  return Number.isInteger(n) && n > 0 ? n : null;
};

const getCaseInsensitive = (obj, key) => {
  if (!obj || typeof obj !== 'object') return undefined;
  const foundKey = Object.keys(obj).find(
    (k) => k.toLowerCase() === String(key).toLowerCase(),
  );
  return foundKey ? obj[foundKey] : undefined;
};

const normalizeArray = (payload) => {
  if (!payload) return [];
  if (Array.isArray(payload)) return payload;

  const directKeys = [
    'Data',
    'data',
    'ClassSubjectList',
    'classSubjectList',
    'List',
    'list',
    'Result',
    'result',
    'Items',
    'items',
    'singleRecord',
    'SingleRecord',
  ];

  for (const k of directKeys) {
    const v = getCaseInsensitive(payload, k);
    if (Array.isArray(v)) return v;
  }

  const nested1 = getCaseInsensitive(payload, 'data');
  const nested2 = getCaseInsensitive(payload, 'Data');

  if (nested1 && typeof nested1 === 'object') {
    const a = normalizeArray(nested1);
    if (a.length) return a;
  }
  if (nested2 && typeof nested2 === 'object') {
    const a = normalizeArray(nested2);
    if (a.length) return a;
  }

  return [];
};

const flattenIfGrouped = (arr) => {
  if (!Array.isArray(arr) || arr.length === 0) return [];

  const hasInnerList = arr.some((x) => {
    const a1 = getCaseInsensitive(x, 'SubjectList');
    const a2 = getCaseInsensitive(x, 'subjectList');
    const a3 = getCaseInsensitive(x, 'Subjects');
    const a4 = getCaseInsensitive(x, 'subjects');
    return (
      Array.isArray(a1) ||
      Array.isArray(a2) ||
      Array.isArray(a3) ||
      Array.isArray(a4)
    );
  });

  if (!hasInnerList) return arr;

  const flat = [];
  arr.forEach((x) => {
    const a1 = getCaseInsensitive(x, 'SubjectList');
    const a2 = getCaseInsensitive(x, 'subjectList');
    const a3 = getCaseInsensitive(x, 'Subjects');
    const a4 = getCaseInsensitive(x, 'subjects');

    const inner =
      (Array.isArray(a1) && a1) ||
      (Array.isArray(a2) && a2) ||
      (Array.isArray(a3) && a3) ||
      (Array.isArray(a4) && a4) ||
      [];

    inner.forEach((y) => flat.push(y));
  });

  return flat;
};

// ✅ Today date in YYYY-MM-DD (timezone-safe)
const getTodayInputDate = () => {
  const d = new Date();
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
};

const TODAY = getTodayInputDate();

// ✅ Date helper (timezone-safe)
const DateHelper = {
  toInputDate(d) {
    if (!d) return '';
    if (typeof d === 'string') {
      const s = d.trim();
      if (/^\d{4}-\d{2}-\d{2}/.test(s)) return s.slice(0, 10);
    }
    const dt = new Date(d);
    if (Number.isNaN(dt.getTime())) return '';
    const yyyy = dt.getFullYear();
    const mm = String(dt.getMonth() + 1).padStart(2, '0');
    const dd = String(dt.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  },
};

// -----------------------------
// Course Structure helpers
// -----------------------------
const normalizeCourseStructure = (raw) => {
  const s = String(raw ?? '')
    .trim()
    .toLowerCase();
  if (!s) return 'semester';
  if (s.includes('year')) return 'year';
  if (s.includes('month')) return 'month';
  if (s.includes('sem')) return 'semester';
  return 'semester';
};

const structureWordUpper = (raw) => {
  const s = normalizeCourseStructure(raw);
  if (s === 'year') return 'YEAR';
  if (s === 'month') return 'MONTH';
  return 'SEMESTER';
};

// const structureHeader = (raw, index1Based) =>
//   `${structureWordUpper(raw)} - ${index1Based}`;

// -----------------------------
// Pattern helpers
// -----------------------------
const getPatternId = (p) =>
  Number(p?.id ?? p?.pattern_id ?? p?.PatternId ?? p?.ID ?? 0) || 0;

const getPatternTermName = (p) =>
  String(
    pick(
      p?.term_name,
      p?.Term_Name,
      p?.termName,
      p?.TermName,
      p?.pattern_name,
      p?.PatternName,
      p?.name,
      p?.Name,
      '',
    ),
  );

// -----------------------------
// Subject pickers
// -----------------------------
const pickSubjectId = (s) => {
  const direct =
    s?.subject_id ??
    s?.SubjectId ??
    s?.Subject_ID ??
    s?.subjectId ??
    s?.SubjectID ??
    s?.id ??
    s?.ID ??
    s?.subject_master_id ??
    s?.subjectMasterId ??
    s?.SubjectMasterId;

  const nested =
    s?.subject?.id ??
    s?.subject?.subject_id ??
    s?.Subject?.id ??
    s?.Subject?.subject_id;

  return Number(direct ?? nested ?? 0);
};

const pickSubjectName = (s) => {
  const direct =
    s?.subject_name ?? s?.Subject_Name ?? s?.name ?? s?.Name ?? s?.subjectName;

  const nested =
    s?.subject?.subject_name ??
    s?.subject?.name ??
    s?.Subject?.subject_name ??
    s?.Subject?.name;

  return String(direct ?? nested ?? '');
};

const pickSubjectCode = (s) => {
  const direct =
    s?.subject_code ?? s?.Subject_Code ?? s?.code ?? s?.subjectCode;

  const nested =
    s?.subject?.subject_code ??
    s?.subject?.code ??
    s?.Subject?.subject_code ??
    s?.Subject?.code;

  return String(direct ?? nested ?? '');
};

const pickSubjectSemesterNo = (s) => {
  const v =
    s?.semester ??
    s?.Semester ??
    s?.semester_no ??
    s?.Semester_No ??
    s?.semesterNo ??
    getCaseInsensitive(s, 'semester') ??
    getCaseInsensitive(s, 'semester_no') ??
    getCaseInsensitive(s, 'semesterNo') ??
    1;

  return Number(v || 1);
};

// -----------------------------
// Batch helpers
// -----------------------------
const getBatchId = (b) =>
  Number(b?.id ?? b?.batch_id ?? b?.ID ?? b?.BatchId ?? 0) || 0;
const getBatchName = (b) =>
  String(pick(b?.batch_name, b?.BatchName, b?.name, b?.Name, ''));
const getBatchCode = (b) =>
  String(pick(b?.batch_code, b?.BatchCode, b?.code, b?.Code, ''));

// ✅ react-select style
const selectStyles = {
  control: (base) => ({ ...base, minHeight: 36, height: 36, fontSize: 14 }),
  valueContainer: (base) => ({ ...base, height: 36, padding: '0 8px' }),
  input: (base) => ({ ...base, margin: 0, padding: 0 }),
  indicatorsContainer: (base) => ({ ...base, height: 36 }),
};

const AddEditBatchExamMaster = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useSelector((state) => state.authState);
  const { isSuperAdmin, isAdmin, hasMultiBranch, hasSingleBranch } =
    useVendorBranch(user);

  const [batchErrors, setBatchErrors] = useState({});

  const [courseOptions, setCourseOptions] = useState([]);
  const [courseLoading, setCourseLoading] = useState(false);

  const [batchOptions, setBatchOptions] = useState([]);
  const [batchLoading, setBatchLoading] = useState(false);

  const [patternOptions, setPatternOptions] = useState([]);
  const [patternLoading, setPatternLoading] = useState(false);

  const [selectedSemester, setSelectedSemester] = useState('');
  const [isLoaded, setIsLoaded] = useState(false);

  const [subjectsLoading, setSubjectsLoading] = useState(false);
  const [allSubjects, setAllSubjects] = useState([]);
  const [existingSchedule, setExistingSchedule] = useState([]);
  const [scheduleRows, setScheduleRows] = useState([]);

  // ✅ NEW: examDate errors map { subject_id: "Required" }
  const [examDateErrors, setExamDateErrors] = useState({});

  const [batchExamData, setBatchExamData] = useState({
    id: 0,
    vendor_id: '',
    branch_id: '',

    class_id: '',
    class_name: '',
    total_semester: 0,
    course_structure: 'semester',

    batch_id: '',
    batch_name: '',
    batch_code: '',

    pattern_id: '',
    pattern_name: '',

    start_date: TODAY,
    end_date: TODAY,

    is_published: false,
    exam_conduct_status: 'Planned',

    sem_no: null,
  });

  const isEditMode = useMemo(
    () => Number(batchExamData.id || 0) > 0,
    [batchExamData.id],
  );

  const asList = (data) => {
    if (Array.isArray(data)) return data;
    const arr = normalizeArray(data);
    return Array.isArray(arr) ? arr : [];
  };

  const extractList = (response) => {
    if (!response) return [];
    let list = asList(response.data);
    if (!list.length) list = asList(response);
    return Array.isArray(list) ? list : [];
  };

  // -----------------------------------------
  // ✅ Prefill from navigation state / EDIT
  // -----------------------------------------
  useEffect(() => {
    const st = location.state;
    if (!st) return;

    const resolvedClassId = toPositiveIntOrNull(
      pick(st?.class_id, st?.classId, st?.course_id, st?.courseId, ''),
    );

    const resolvedBatchId = toPositiveIntOrNull(
      pick(st?.batch_id, st?.batchId, st?.id_batch, ''),
    );

    const resolvedPatternId = toPositiveIntOrNull(
      pick(st?.pattern_id, st?.patternId, ''),
    );

    const semFromState =
      Number(st?.sem_no ?? st?.semNo ?? st?.semester_no ?? 0) || null;

    setBatchExamData((prev) => ({
      ...prev,
      ...st,
      vendor_id: pick(st?.vendor_id, st?.vendorId, prev.vendor_id),
      branch_id: pick(st?.branch_id, st?.branchId, prev.branch_id),

      class_id: resolvedClassId ? String(resolvedClassId) : '',
      class_name: pick(
        st?.class_name,
        st?.className,
        st?.course_name,
        st?.courseName,
        prev.class_name,
        '',
      ),

      batch_id: resolvedBatchId ? String(resolvedBatchId) : '',
      batch_name: pick(st?.batch_name, st?.batchName, prev.batch_name, ''),
      batch_code: pick(st?.batch_code, st?.batchCode, prev.batch_code, ''),

      pattern_id: resolvedPatternId ? String(resolvedPatternId) : '',
      pattern_name: pick(st?.pattern_name, st?.patternName, prev.pattern_name, ''),

      total_semester: Number(
        pick(st?.total_semester, st?.totalSemester, prev.total_semester, 0),
      ),
      course_structure: normalizeCourseStructure(
        pick(
          st?.course_structure,
          st?.courseStructure,
          prev.course_structure,
          'semester',
        ),
      ),

      start_date: st?.start_date
        ? DateHelper.toInputDate(st.start_date)
        : prev.start_date || TODAY,
      end_date: st?.end_date
        ? DateHelper.toInputDate(st.end_date)
        : prev.end_date || TODAY,

      exam_conduct_status: pick(
        st?.exam_conduct_status,
        prev.exam_conduct_status,
        'Planned',
      ),
      is_published: !!pick(st?.is_published, prev.is_published, false),
      sem_no: semFromState ?? prev.sem_no ?? null,
    }));

    if (Number(st?.id || 0) > 0 && semFromState) {
      setSelectedSemester(String(semFromState));
      setIsLoaded(true);
    } else {
      setSelectedSemester('');
      setIsLoaded(false);
      setScheduleRows([]);
    }
  }, [location.state]);

  // -----------------------------------------
  // ✅ Courses
  // -----------------------------------------
  const fetchCourses = async (searchText = '') => {
    try {
      const vendorId = batchExamData.vendor_id || '';
      const branchId = batchExamData.branch_id || '';

      const canLoad = conditionalDataLoad({
        hasMultiBranch,
        hasSingleBranch,
        isSuperAdmin,
        isAdmin,
        vendorId,
        branchId,
      });

      if (!canLoad) {
        setCourseOptions([]);
        return;
      }

      setCourseLoading(true);

      const res = await apiService.get(
        `api/ClassMaster/GetClassMaster?vendorId=${vendorId}&branchId=${branchId}&searchItem=${encodeURIComponent(
          searchText || '',
        )}`,
      );

      if (res?.status === true) {
        const list = extractList(res) || [];

        const opts = (list || []).map((x) => ({
          value: Number(x?.id ?? x?.class_id ?? x?.ClassId ?? 0),
          label: pick(
            x?.class_Name,
            x?.class_name,
            x?.class_display_name,
            x?.className,
            x?.course_name,
            'No Name',
          ),
          meta: {
            total_semester:
              Number(
                pick(x?.total_semester, x?.Total_Semester, x?.totalSemester, 0),
              ) || 0,
            course_structure: normalizeCourseStructure(
              pick(
                x?.course_structure,
                x?.Course_Structure,
                x?.courseStructure,
                'semester',
              ),
            ),
          },
        }));

        setCourseOptions(opts.filter((o) => o.value > 0));
      } else {
        setCourseOptions([]);
      }
    } catch (err) {
      console.log(err);
      setCourseOptions([]);
    } finally {
      setCourseLoading(false);
    }
  };

  useEffect(() => {
    const canLoad = conditionalDataLoad({
      hasMultiBranch,
      hasSingleBranch,
      isSuperAdmin,
      isAdmin,
      vendorId: batchExamData.vendor_id,
      branchId: batchExamData.branch_id,
    });

    if (!canLoad) return;
    fetchCourses('');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [batchExamData.vendor_id, batchExamData.branch_id]);

  // -----------------------------------------
  // ✅ Batches
  // -----------------------------------------
  const fetchBatches = async (classIdArg, searchText = '') => {
    try {
      const vendorId = batchExamData.vendor_id || '';
      const branchId = batchExamData.branch_id || '';
      const classId = toPositiveIntOrNull(classIdArg);

      if (!classId) {
        setBatchOptions([]);
        return;
      }

      setBatchLoading(true);

      const res = await apiService.get(
        `api/BatchMaster/GetAllBatch?vendorId=${vendorId}&branchId=${branchId}&classId=${classId}&search=${encodeURIComponent(
          searchText || '',
        )}`,
      );

      if (res?.status === true) {
        const list = extractList(res) || [];

        const opts = (list || []).map((b) => {
          const id = getBatchId(b);
          const name = getBatchName(b);
          const code = getBatchCode(b);
          return {
            value: id,
            label: code ? `${code} - ${name}` : name || `Batch-${id}`,
            meta: { name, code },
          };
        });

        setBatchOptions(opts.filter((o) => o.value > 0));
      } else {
        setBatchOptions([]);
      }
    } catch (e) {
      console.log(e);
      setBatchOptions([]);
    } finally {
      setBatchLoading(false);
    }
  };

  useEffect(() => {
    const cid = toPositiveIntOrNull(batchExamData.class_id);
    if (!cid) {
      setBatchOptions([]);
      return;
    }
    fetchBatches(cid, '');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    batchExamData.class_id,
    batchExamData.vendor_id,
    batchExamData.branch_id,
  ]);

  // -----------------------------------------
  // ✅ Patterns
  // -----------------------------------------
  const fetchPatterns = async (classIdArg, searchText = '') => {
    try {
      const vendorId = batchExamData.vendor_id || '';
      const branchId = batchExamData.branch_id || '';
      const courseId = toPositiveIntOrNull(classIdArg);

      if (!courseId) {
        setPatternOptions([]);
        return;
      }

      setPatternLoading(true);

      const res = await apiService.get(
        `api/ExamMaster/GetAllCourseExamPattern?courseId=${courseId}&vendorId=${vendorId}&branchId=${branchId}&search=${encodeURIComponent(
          searchText || '',
        )}`,
      );

      if (res?.status === true) {
        const list = extractList(res) || [];

        const opts = (list || []).map((p) => {
          const id = getPatternId(p);
          const term = getPatternTermName(p);
          return { value: id, label: term || `Pattern-${id}` };
        });

        setPatternOptions(opts.filter((o) => o.value > 0));
      } else {
        setPatternOptions([]);
      }
    } catch (e) {
      console.log(e);
      setPatternOptions([]);
    } finally {
      setPatternLoading(false);
    }
  };

  useEffect(() => {
    const cid = toPositiveIntOrNull(batchExamData.class_id);
    if (!cid) {
      setPatternOptions([]);
      return;
    }
    fetchPatterns(cid, '');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    batchExamData.class_id,
    batchExamData.vendor_id,
    batchExamData.branch_id,
  ]);

  const selectedPatternTerm = useMemo(() => {
    const pid = Number(batchExamData.pattern_id || 0);
    if (!pid) return '';
    const found = patternOptions.find((p) => Number(p.value) === pid);
    return found?.label || batchExamData.pattern_name || '';
  }, [batchExamData.pattern_id, batchExamData.pattern_name, patternOptions]);

  // -----------------------------------------
  // ✅ Subjects / Schedule APIs
  // -----------------------------------------
  const GetClassSubjects = async () => {
    try {
      const vendorId = toPositiveIntOrNull(batchExamData.vendor_id);
      const branchId = toPositiveIntOrNull(batchExamData.branch_id);
      const classId = toPositiveIntOrNull(batchExamData.class_id);

      if (!classId) return [];

      const response = await apiService.get(
        `api/ClassMaster/GetClassSubjects?classId=${classId}&vendorId=${
          vendorId || ''
        }&branchId=${branchId || ''}`,
      );

      if (response?.status === true) {
        let list = extractList(response);
        list = flattenIfGrouped(list);

        const cleaned = (Array.isArray(list) ? list : [])
          .map((s) => ({
            subject_id: pickSubjectId(s),
            subject_name: pickSubjectName(s),
            subject_code: pickSubjectCode(s),
            semester_no: pickSubjectSemesterNo(s) || 1,
          }))
          .filter((x) => Number(x.subject_id) > 0);

        return cleaned;
      }

      toast.error(response?.message || 'Failed to load subjects');
      return [];
    } catch (error) {
      console.log(error);
      toast.error('Something went wrong!!');
      return [];
    }
  };

  const GetAllBatchExamSubSchedule = async (
    search = '',
    forceMasterId = null,
  ) => {
    try {
      const vendorId = toPositiveIntOrNull(batchExamData.vendor_id);
      const branchId = toPositiveIntOrNull(batchExamData.branch_id);
      const masterId = Number(forceMasterId ?? batchExamData.id ?? 0);

      if (!masterId) return [];

      const response = await apiService.get(
        `api/BatchExamMaster/GetAllBatchExamSubSchedule?vendorId=${
          vendorId || ''
        }&branchId=${branchId || ''}&batchExamId=${masterId}&search=${search}`,
      );

      if (response?.status === true) {
        const list = extractList(response);

        return (Array.isArray(list) ? list : []).map((x) => ({
          id: x?.id ?? null,
          subject_id: Number(x?.subject_id ?? 0) || 0,
          exam_date: DateHelper.toInputDate(x?.exam_date),
          subject_code: x?.subject_code ?? '',
          subject_name: x?.subject_name ?? '',
        }));
      }
      return [];
    } catch (error) {
      console.log(error);
      return [];
    }
  };

  // ✅ NEW: default exam_date = TODAY for new rows
  const buildRowsForSemester = (semNo, subjectsArr, scheduleArr) => {
    const subjectsOfSem = (subjectsArr || []).filter(
      (s) => Number(s.semester_no || 1) === Number(semNo),
    );

    const exMap = {};
    (scheduleArr || []).forEach((x) => {
      const sid = Number(x.subject_id || 0);
      if (!sid) return;
      exMap[sid] = {
        id: x.id ?? null,
        exam_date: x.exam_date || '',
        subject_code: x.subject_code || '',
        subject_name: x.subject_name || '',
      };
    });

    return subjectsOfSem.map((s) => ({
      id: exMap[s.subject_id]?.id ?? null,
      subject_id: s.subject_id,
      subject_name: s.subject_name || exMap[s.subject_id]?.subject_name || '',
      subject_code: s.subject_code || exMap[s.subject_id]?.subject_code || '',
      semester_no: s.semester_no || semNo,
      exam_date: exMap[s.subject_id]?.exam_date ?? TODAY,
    }));
  };

  const preloadSubjectsAndExisting = useCallback(async () => {
    const classId = toPositiveIntOrNull(batchExamData.class_id);
    const masterId = Number(batchExamData.id || 0);

    if (!classId) {
      setAllSubjects([]);
      setExistingSchedule([]);
      setIsLoaded(false);
      setScheduleRows([]);
      setExamDateErrors({});
      return;
    }

    try {
      setSubjectsLoading(true);

      const subjects = await GetClassSubjects();

      let existing = [];
      if (masterId > 0) {
        existing = await GetAllBatchExamSubSchedule('', masterId);
      }

      setAllSubjects(subjects || []);
      setExistingSchedule(existing || []);

      if (masterId > 0) {
        let sem = Number(batchExamData.sem_no || 0);
        if (!sem && selectedSemester) sem = Number(selectedSemester || 0);

        const finalSem = sem || 1;
        setSelectedSemester(String(finalSem));

        const rows = buildRowsForSemester(
          finalSem,
          subjects || [],
          existing || [],
        );
        setScheduleRows(rows);
        setIsLoaded(true);
      } else {
        setIsLoaded(false);
        setScheduleRows([]);
      }
    } finally {
      setSubjectsLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    batchExamData.vendor_id,
    batchExamData.branch_id,
    batchExamData.class_id,
    batchExamData.id,
    batchExamData.sem_no,
    selectedSemester,
  ]);

  useEffect(() => {
    preloadSubjectsAndExisting();
  }, [preloadSubjectsAndExisting]);

  // -----------------------------------------
  // ✅ react-select handlers
  // -----------------------------------------
  const onCourseSelect = (opt) => {
    const classId = toPositiveIntOrNull(opt?.value);

    setSelectedSemester('');
    setIsLoaded(false);
    setScheduleRows([]);
    setExistingSchedule([]);
    setAllSubjects([]);
    setExamDateErrors({});

    setBatchExamData((prev) => ({
      ...prev,
      class_id: classId ? String(classId) : '',
      class_name: opt?.label || '',
      total_semester: opt?.meta?.total_semester || 0,
      course_structure: opt?.meta?.course_structure || 'semester',

      batch_id: '',
      batch_name: '',
      batch_code: '',
      pattern_id: '',
      pattern_name: '',

      sem_no: null,
      start_date: prev.start_date || TODAY,
      end_date: prev.end_date || TODAY,
    }));

    if (classId) {
      fetchBatches(classId, '');
      fetchPatterns(classId, '');
    } else {
      setBatchOptions([]);
      setPatternOptions([]);
    }
  };

  const onBatchSelect = (opt) => {
    setBatchExamData((prev) => ({
      ...prev,
      batch_id: opt?.value ? String(opt.value) : '',
      batch_name: opt?.meta?.name || '',
      batch_code: opt?.meta?.code || '',
    }));
  };

  const onPatternSelect = (opt) => {
    const pid = opt?.value ? String(opt.value) : '';
    const pname = opt?.label || '';

    setBatchExamData((prev) => ({
      ...prev,
      pattern_id: pid,
      pattern_name: pname,
    }));

    if (!isEditMode) {
      setIsLoaded(false);
      setScheduleRows([]);
      setExamDateErrors({});
    }
  };

  // -----------------------------------------
  // ✅ Semester change
  // -----------------------------------------
  const onSemesterChange = (val) => {
    setSelectedSemester(val);

    const semNo = Number(val || 0) || null;
    setBatchExamData((prev) => ({
      ...prev,
      sem_no: semNo,
    }));

    setExamDateErrors({});

    if (!semNo) {
      setIsLoaded(false);
      setScheduleRows([]);
      return;
    }

    if (isEditMode) {
      const rows = buildRowsForSemester(
        semNo,
        allSubjects || [],
        existingSchedule || [],
      );
      setScheduleRows(rows);
      setIsLoaded(true);
    } else {
      setIsLoaded(false);
      setScheduleRows([]);
    }
  };

  // -----------------------------------------
  // ✅ Load button (ADD only)
  // -----------------------------------------
  const onLoadClick = () => {
    const patternId = Number(batchExamData.pattern_id || 0);
    const semNo = Number(selectedSemester || 0);

    if (!batchExamData.class_id || Number(batchExamData.class_id) <= 0) {
      toast.error('Please select Course/Class');
      return;
    }

    if (!batchExamData.batch_id || Number(batchExamData.batch_id) <= 0) {
      toast.error('Please select Batch Name');
      return;
    }

    if (!patternId) {
      toast.error('Please select Pattern');
      return;
    }

    if (!semNo) {
      toast.error(
        `Please select ${structureWordUpper(batchExamData.course_structure)}`,
      );
      return;
    }

    const rows = buildRowsForSemester(
      semNo,
      allSubjects || [],
      existingSchedule || [],
    );

    if (!rows.length) {
      toast.error(
        `No subjects found for ${structureWordUpper(
          batchExamData.course_structure,
        )} ${semNo}`,
      );
      setScheduleRows([]);
      setIsLoaded(false);
      return;
    }

    setScheduleRows(rows);
    setIsLoaded(true);
    setExamDateErrors({});
  };

  // ✅ NEW: exam date change + clear error
  const updateExamDate = (subjectId, value) => {
    setScheduleRows((prev) =>
      prev.map((r) =>
        Number(r.subject_id) === Number(subjectId)
          ? { ...r, exam_date: value }
          : r,
      ),
    );

    setExamDateErrors((prev) => {
      if (!prev || !prev[subjectId]) return prev;
      const clone = { ...prev };
      delete clone[subjectId];
      return clone;
    });
  };

  // -----------------------------------------
  // ✅ Validation
  // -----------------------------------------
  const validateBeforeSave = () => {
    setExamDateErrors({});

    if (
      isSuperAdmin &&
      (!batchExamData.vendor_id || Number(batchExamData.vendor_id) <= 0)
    ) {
      toast.error('Please select Vendor');
      return false;
    }

    if (
      (isSuperAdmin || isAdmin || hasMultiBranch) &&
      (!batchExamData.branch_id || Number(batchExamData.branch_id) <= 0)
    ) {
      toast.error('Please select Branch');
      return false;
    }

    if (!batchExamData.class_id || Number(batchExamData.class_id) <= 0) {
      toast.error('Please select Course/Class');
      return false;
    }

    if (!batchExamData.batch_id || Number(batchExamData.batch_id) <= 0) {
      toast.error('Please select Batch Name');
      return false;
    }

    if (!batchExamData.pattern_id || Number(batchExamData.pattern_id) <= 0) {
      toast.error('Please select Pattern');
      return false;
    }

    if (!selectedSemester || Number(selectedSemester) <= 0) {
      toast.error(
        `Please select ${structureWordUpper(batchExamData.course_structure)}`,
      );
      return false;
    }

    if (!isLoaded) {
      toast.error(isEditMode ? 'Schedule not loaded' : 'Please click Load');
      return false;
    }

    if (!batchExamData.exam_conduct_status) {
      toast.error('Please select Exam Conduct Status');
      return false;
    }

    if (!batchExamData.start_date) {
      toast.error('Please select Start Date');
      return false;
    }

    if (!batchExamData.end_date) {
      toast.error('Please select End Date');
      return false;
    }

    if (batchExamData.start_date < TODAY) {
      toast.error('Start Date past me nahi ho sakti.');
      return false;
    }
    if (batchExamData.end_date < TODAY) {
      toast.error('End Date past me nahi ho sakti.');
      return false;
    }

    if (batchExamData.end_date < batchExamData.start_date) {
      toast.error('End Date, Start Date se chhoti nahi ho sakti.');
      return false;
    }

    const errs = {};
    (scheduleRows || []).forEach((r) => {
      const v = String(r.exam_date || '').trim();
      if (!v) errs[r.subject_id] = 'Exam Date required hai';
      else if (v < TODAY) errs[r.subject_id] = 'Past date allowed nahi hai';
    });

    if (Object.keys(errs).length > 0) {
      setExamDateErrors(errs);
      toast.error('Please fill Exam Date for all subjects.');
      return false;
    }

    return true;
  };

  // -----------------------------------------
  // ✅ Save
  // -----------------------------------------
  const SaveBatchExamMaster = async () => {
    if (!validateBeforeSave()) return;

    try {
      const payload = {
        id: batchExamData.id ? Number(batchExamData.id) : null,
        vendor_id: batchExamData.vendor_id
          ? Number(batchExamData.vendor_id)
          : null,
        branch_id: batchExamData.branch_id
          ? Number(batchExamData.branch_id)
          : null,

        class_id: batchExamData.class_id
          ? Number(batchExamData.class_id)
          : null,
        class_name: batchExamData.class_name || null,

        batch_id: batchExamData.batch_id
          ? Number(batchExamData.batch_id)
          : null,
        batch_name: batchExamData.batch_name || null,
        batch_code: batchExamData.batch_code || null,

        pattern_id: batchExamData.pattern_id
          ? Number(batchExamData.pattern_id)
          : null,
        pattern_name: batchExamData.pattern_name || selectedPatternTerm || null,

        start_date: batchExamData.start_date || null,
        end_date: batchExamData.end_date || null,

        is_published: !!batchExamData.is_published,
        exam_conduct_status: batchExamData.exam_conduct_status,

        sem_no: Number(selectedSemester || 0) || null,

        sub_schedule_list: (scheduleRows || [])
          .filter((r) => Number(r.subject_id) > 0)
          .map((r) => ({
            id: r?.id ? Number(r.id) : null,
            subject_id: Number(r.subject_id),
            exam_date: r.exam_date || null,

            subject_code: r.subject_code || null,
            subject_name: r.subject_name || null,

            vendor_id: batchExamData.vendor_id
              ? Number(batchExamData.vendor_id)
              : null,
            branch_id: batchExamData.branch_id
              ? Number(batchExamData.branch_id)
              : null,

            exam_conduct_status: batchExamData.exam_conduct_status,
            class_id: batchExamData.class_id
              ? Number(batchExamData.class_id)
              : null,
            class_name: batchExamData.class_name || null,
            batch_name: batchExamData.batch_name || null,
            batch_code: batchExamData.batch_code || null,
          })),
      };

      let res;
      if (batchExamData.id && Number(batchExamData.id) > 0) {
        res = await apiService.put(
          `api/BatchExamMaster/UpdateBatchExamMaster?id=${batchExamData.id}`,
          payload,
        );
      } else {
        res = await apiService.post(
          'api/BatchExamMaster/AddBatchExamMaster',
          payload,
        );
      }

      if (res?.status === true) {
        toast.success(res.message || 'Saved');
        navigate('/list-batch-exam');
      } else {
        toast.error(res?.message || 'Failed');
      }
    } catch (err) {
      console.error(err);
      toast.error('Something went wrong');
    }
  };

  // -----------------------------------------
  // UI
  // -----------------------------------------
  const courseStructure = batchExamData.course_structure || 'semester';
  const totalSemesters = Number(batchExamData.total_semester || 0);

  const canLoad =
    !!batchExamData.class_id &&
    Number(batchExamData.class_id) > 0 &&
    !!batchExamData.batch_id &&
    Number(batchExamData.batch_id) > 0 &&
    !!batchExamData.pattern_id &&
    Number(batchExamData.pattern_id) > 0 &&
    !!selectedSemester &&
    Number(selectedSemester) > 0;

  const selectedCourseOpt = useMemo(
    () =>
      courseOptions.find(
        (o) => Number(o.value) === Number(batchExamData.class_id),
      ) || null,
    [courseOptions, batchExamData.class_id],
  );

  const selectedBatchOpt = useMemo(
    () =>
      batchOptions.find(
        (o) => Number(o.value) === Number(batchExamData.batch_id),
      ) || null,
    [batchOptions, batchExamData.batch_id],
  );

  const selectedPatternOpt = useMemo(
    () =>
      patternOptions.find(
        (o) => Number(o.value) === Number(batchExamData.pattern_id),
      ) || null,
    [patternOptions, batchExamData.pattern_id],
  );

  return (
    <>
      <VendorBranchSelector
        user={user}
        selectionData={batchExamData}
        setSelectionData={setBatchExamData}
        errorMessage={batchErrors}
        accessButton={true}
      />

      <Card className='card-box pd-20 mb-20'>
        <CardTitle className='border-bottom p-3 d-flex justify-content-between align-items-center'>
          <span>Batch Exam Master Form</span>

          <div className='d-flex gap-2'>
            <Button color='primary' onClick={SaveBatchExamMaster}>
              Save
            </Button>
            <Button color='warning' onClick={() => navigate(-1)}>
              <i className='bi bi-arrow-left' />
            </Button>
          </div>
        </CardTitle>

        <CardBody>
          <Row>
            <FormGroup className='col-sm-6'>
              <Label>Course / Class</Label>
              <Select
                styles={selectStyles}
                options={courseOptions}
                value={selectedCourseOpt}
                isLoading={courseLoading}
                isSearchable
                isClearable
                placeholder='Search courses ...'
                onChange={onCourseSelect}
                onInputChange={(inputValue, actionMeta) => {
                  if (actionMeta.action === 'input-change') {
                    fetchCourses(inputValue);
                  }
                }}
              />
            </FormGroup>

            <FormGroup className='col-sm-6'>
              <Label>Batch Name</Label>
              <Select
                styles={selectStyles}
                options={batchOptions}
                value={selectedBatchOpt}
                isLoading={batchLoading}
                isSearchable
                isClearable
                placeholder='Search batches ...'
                onChange={onBatchSelect}
                onInputChange={(inputValue, actionMeta) => {
                  if (actionMeta.action === 'input-change') {
                    fetchBatches(batchExamData.class_id, inputValue);
                  }
                }}
                isDisabled={!batchExamData.class_id}
              />
            </FormGroup>

            <FormGroup className='col-sm-6'>
              <Label>Pattern (Term Name)</Label>
              <Select
                styles={selectStyles}
                options={patternOptions}
                value={selectedPatternOpt}
                isLoading={patternLoading}
                isSearchable
                isClearable
                placeholder='Search patterns ...'
                onChange={onPatternSelect}
                onInputChange={(inputValue, actionMeta) => {
                  if (actionMeta.action === 'input-change') {
                    fetchPatterns(batchExamData.class_id, inputValue);
                  }
                }}
                isDisabled={!batchExamData.class_id}
              />
              {batchExamData.pattern_id ? (
                <small className='text-muted'>
                  Selected:{' '}
                  {selectedPatternTerm ||
                    `Pattern ID: ${batchExamData.pattern_id}`}
                </small>
              ) : null}
            </FormGroup>

            <FormGroup className='col-sm-6'>
              <Label>Select {structureWordUpper(courseStructure)}</Label>
              <select
                className='form-control'
                value={selectedSemester}
                onChange={(e) => onSemesterChange(e.target.value)}
                disabled={!totalSemesters}
              >
                <option value=''>
                  {totalSemesters ? 'Select' : 'Select Course first'}
                </option>
                {[...Array(totalSemesters || 0)].map((_, index) => (
                  <option key={index + 1} value={index + 1}>
                    {structureWordUpper(courseStructure)} {index + 1}
                  </option>
                ))}
              </select>
            </FormGroup>

            <FormGroup className='col-sm-3'>
              <Label>Exam Conduct Status</Label>
              <Input
                type='select'
                className='custom-select'
                name='exam_conduct_status'
                value={batchExamData.exam_conduct_status || ''}
                onChange={(e) =>
                  setBatchExamData((p) => ({
                    ...p,
                    exam_conduct_status: e.target.value,
                  }))
                }
              >
                <option value='Planned'>Planned</option>
                <option value='Scheduled'>Scheduled</option>
                <option value='Conducted'>Conducted</option>
              </Input>
            </FormGroup>

            <FormGroup className='col-sm-3'>
              <Label>Start Date</Label>
              <Input
                type='date'
                value={batchExamData.start_date || TODAY}
                min={TODAY}
                onChange={(e) =>
                  setBatchExamData((p) => ({
                    ...p,
                    start_date: e.target.value,
                  }))
                }
              />
            </FormGroup>

            <FormGroup className='col-sm-3'>
              <Label>End Date</Label>
              <Input
                type='date'
                value={batchExamData.end_date || TODAY}
                min={TODAY}
                onChange={(e) =>
                  setBatchExamData((p) => ({ ...p, end_date: e.target.value }))
                }
              />
            </FormGroup>

            <FormGroup className='col-sm-3 d-flex align-items-center'>
              <Label check className='mt-4'>
                <Input
                  type='checkbox'
                  checked={!!batchExamData.is_published}
                  onChange={(e) =>
                    setBatchExamData((p) => ({
                      ...p,
                      is_published: e.target.checked,
                    }))
                  }
                />{' '}
                Published
              </Label>
            </FormGroup>

            {!isEditMode ? (
              <FormGroup className='col-sm-2 d-flex align-items-end'>
                <Button
                  color='info'
                  size='sm'
                  style={{ width: '100%' }}
                  onClick={onLoadClick}
                  disabled={!canLoad || subjectsLoading}
                >
                  {subjectsLoading ? '...' : 'Load'}
                </Button>
              </FormGroup>
            ) : null}
          </Row>

          <hr className='my-4' />

          {subjectsLoading ? (
            <div className='text-muted'>Loading subjects...</div>
          ) : !batchExamData.class_id ? (
            <div className='text-muted'>Please select Course/Class.</div>
          ) : !batchExamData.batch_id ? (
            <div className='text-muted'>Please select Batch Name.</div>
          ) : !batchExamData.pattern_id ? (
            <div className='text-muted'>Please select Pattern.</div>
          ) : !selectedSemester ? (
            <div className='text-muted'>
              Please select {structureWordUpper(courseStructure)}.
            </div>
          ) : !isLoaded ? (
            <div className='text-muted'>
              {isEditMode ? (
                <>Loading schedule...</>
              ) : (
                <>
                  Click <b>Load</b> to show subjects.
                </>
              )}
            </div>
          ) : (
            <Table bordered responsive size='sm'>
              <thead>
                <tr>
                  <th style={{ width: 60 }}>#</th>
                  <th style={{ width: 200 }}>Subject Code</th>
                  <th>Subject Name</th>
                  <th style={{ width: 240 }}>Exam Date</th>
                </tr>
              </thead>
              <tbody>
                {scheduleRows.length === 0 ? (
                  <tr>
                    <td colSpan={4} className='text-center text-muted'>
                      No subjects found for selected{' '}
                      {structureWordUpper(courseStructure)}
                    </td>
                  </tr>
                ) : (
                  scheduleRows.map((r, idx) => {
                    const errMsg = examDateErrors?.[r.subject_id];
                    return (
                      <tr key={`${selectedSemester}_${r.subject_id}`}>
                        <td>{idx + 1}</td>
                        <td>
                          <Input
                            type='text'
                            value={r.subject_code || ''}
                            readOnly
                          />
                        </td>
                        <td>
                          <Input
                            type='text'
                            value={r.subject_name || ''}
                            readOnly
                          />
                        </td>
                        <td>
                          <Input
                            type='date'
                            value={r.exam_date || TODAY}
                            min={TODAY}
                            className={errMsg ? 'is-invalid' : ''}
                            onChange={(e) =>
                              updateExamDate(r.subject_id, e.target.value)
                            }
                          />
                          {errMsg ? (
                            <FormText color='danger'>{errMsg}</FormText>
                          ) : null}
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </Table>
          )}
        </CardBody>
      </Card>
    </>
  );
};

export default AddEditBatchExamMaster;